<section class="about" aria-labelledby="about-title">
  <div class="about__inner">
    <article class="about__card">
      <div class="about__grid">
        <div class="about__pillar">
          <span class="about__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </span>
          <h3 class="about__pillar-title">Vídeo</h3>
          <p class="about__pillar-text">Registros dinâmicos em tempo real.</p>
        </div>
        <div class="about__pillar">
          <span class="about__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <circle cx="12" cy="13" r="3" />
            </svg>
          </span>
          <h3 class="about__pillar-title">Foto</h3>
          <p class="about__pillar-text">Imagens otimizadas para redes.</p>
        </div>
        <div class="about__pillar">
          <span class="about__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </span>
          <h3 class="about__pillar-title">Agilidade</h3>
          <p class="about__pillar-text">Conteúdo publicado durante o evento.</p>
        </div>
        <div class="about__pillar">
          <span class="about__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
            </svg>
          </span>
          <h3 class="about__pillar-title">Criativo</h3>
          <p class="about__pillar-text">Direção com linguagem digital.</p>
        </div>
      </div>
      <p id="about-title" class="about__text">
        A <strong>Loba Cria</strong> realiza coberturas estratégicas para eventos, produzindo
        vídeos, fotos e conteúdos otimizados para redes sociais em tempo real. Nossa atuação
        une agilidade, direção criativa e linguagem digital para ampliar o alcance e a
        experiência do evento além do presencial.
      </p>
    </article>
  </div>
</section>
